import { useEffect, useRef } from 'react';

export function useWakeLock(enabled: boolean): { active: boolean } {
  const sentinelRef = useRef<any>(null);
  const activeRef = useRef(false);

  useEffect(() => {
    let cancelled = false;
    async function acquire() {
      try {
        const wl = (navigator as any).wakeLock;
        if (!wl?.request) return;
        const sentinel = await wl.request('screen');
        if (cancelled) {
          await sentinel.release();
          return;
        }
        sentinelRef.current = sentinel;
        activeRef.current = true;
        sentinel.addEventListener?.('release', () => {
          activeRef.current = false;
        });
      } catch {}
    }
    async function release() {
      try {
        await sentinelRef.current?.release?.();
      } catch {}
      sentinelRef.current = null;
      activeRef.current = false;
    }
    function onVisible() {
      if (document.visibilityState === 'visible' && enabled && !sentinelRef.current) {
        void acquire();
      }
    }
    if (enabled) {
      void acquire();
      document.addEventListener('visibilitychange', onVisible);
    }
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', onVisible);
      void release();
    };
  }, [enabled]);

  return { active: activeRef.current };
}
